import { useState } from 'react';
import Header from '../../components/Navigation/Header';
import PyschometricCamera from '../../components/PyschometricTest/Camera.jsx';
import Instruction from '../../components/PyschometricTest/Instruction.jsx';
import './PyschometricTest.css';

function PyschometricTest()
{
  const [agreementSign,setAgreementSign]=useState(false);

  const handleAgreement=(e)=>{
    setAgreementSign(e);
  }
    return(
    <>
      <Header/>
        {!agreementSign &&  <Instruction agreementSign={handleAgreement}/>}
        {agreementSign &&  <PyschometricCamera/>}
    
    </>);
}

export default PyschometricTest;